<template>
  <Content class="overview">
    <FlexContainer>
      <FlexItem padding="normal" :grow="true">
        <TabNavigation :items="tabs" :active="currentTab" />
        <div v-show="currentTab === 0" class="tab">
          <DealTable />
        </div>
        <div v-show="currentTab === 1" class="tab">
          <ProductTable />
        </div>
        <div v-show="currentTab === 2" class="tab">
          <div class="list__item" :key="index" v-for="(category, index) in categories">
            <Card>
              <FlexContainer>
                <FlexItem size="10%" padding="normal">
                  <ImageItem :src="category.image" width="80px" />
                </FlexItem>
                <FlexItem padding="normal" :grow="true">
                  <h2>{{ category.name }}</h2>
                </FlexItem>
                <FlexItem padding="normal">
                  <Button type="primary" @onClick="editCategory(category.id)">Edit Category</Button>
                </FlexItem>
              </FlexContainer>
            </Card>
          </div>
        </div>
        <div v-show="currentTab === 3" class="tab">
          <div class="list__item" :key="index" v-for="(publisher, index) in publishers">
            <Card>
              <FlexContainer>
                <FlexItem size="10%" padding="normal">
                  <ImageItem :src="publisher.image" width="80px" />
                </FlexItem>
                <FlexItem padding="normal" :grow="true">
                  <h2>{{ publisher.name }}</h2>
                </FlexItem>
                <FlexItem padding="normal">
                  <Button type="primary" @onClick="editPublisher(publisher.id)">Edit Publisher</Button>
                </FlexItem>
              </FlexContainer>
            </Card>
          </div>
        </div>
      </FlexItem>
    </FlexContainer>
    <Modal :show="showModal.peakDeal" @closeModal="showModal.peakDeal = false">
      <div slot="header">
        <h2>Peak Deal</h2>
      </div>
      <div slot="body"></div>
    </Modal>
    <Modal :show="showModal.deal" @closeModal="showModal.deal = false">
      <div slot="header">
        <h2>{{ formMode.deal }} Deal</h2>
      </div>
      <div slot="body">
        <DealForm
          :mode="formMode.deal"
          :dealId="currentDeal"
          :productId="currentProduct"
          @onSubmit="onSubmit('deal')"
        />
      </div>
    </Modal>
    <Modal :show="showModal.product" @closeModal="showModal.product = false">
      <div slot="header">
        <h2>{{ formMode.product }} Product</h2>
      </div>
      <div slot="body">
        <ProductForm
          :mode="formMode.product"
          :productId="currentProduct"
          @onSubmit="onSubmit('product')"
        />
      </div>
    </Modal>
    <Modal :show="showModal.category" @closeModal="showModal.category = false">
      <div slot="header">
        <h2>Edit Category</h2>
      </div>
      <div slot="body">
        <CategoryForm :categoryId="currentCategory" @onSubmit="onSubmit('category')" />
      </div>
    </Modal>
    <Modal :show="showModal.publisher" @closeModal="showModal.publisher = false">
      <div slot="header">
        <h2>Edit Publisher</h2>
      </div>
      <div slot="body">
        <PublisherForm :publisherId="currentPublisher" @onSubmit="onSubmit('publisher')" />
      </div>
    </Modal>
    <Modal :show="showModal.delete" @closeModal="showModal.delete = false">
      <div slot="header">
        <h2>Are you sure you want to delete {{ currentDeletionItem.name }}?</h2>
      </div>
      <div slot="footer">
        <Button type="secondary" @onClick="showModal.delete = false">Cancel</Button>
        <Button
          v-show="currentDeletionItem.type === 'deal'"
          type="primary"
          @onClick="
            deleteDeal(currentDeletionItem.id);
            showModal.delete = false;
          "
        >Confirm</Button>
        <Button
          v-show="currentDeletionItem.type === 'product'"
          type="primary"
          @onClick="
            deleteProduct(currentDeletionItem.id);
            showModal.delete = false;
          "
        >Confirm</Button>
      </div>
    </Modal>
  </Content>
</template>

<script>
import { orderBy, filter } from "lodash";
import { mapState, mapActions, mapGetters } from "vuex";
import DealForm from "@/components/admin/DealForm";
import ProductForm from "@/components/admin/ProductForm";
import CategoryForm from "@/components/admin/CategoryForm";
import PublisherForm from "@/components/admin/PublisherForm";
import DealTable from "@/components/admin/DealTable";
import ProductTable from "@/components/admin/ProductTable";

export default {
  data: function() {
    return {
      currentTab: 0,
      tabs: [
        { href: "#deals", text: "Deals", onClick: this.onChangeTab },
        { href: "#products", text: "Products", onClick: this.onChangeTab },
        { href: "#categories", text: "Categories", onClick: this.onChangeTab },
        { href: "#publishers", text: "Publishers", onClick: this.onChangeTab }
      ],
      showModal: {
        deal: false,
        product: false,
        category: false,
        publisher: false,
        delete: false
      },
      formMode: {
        deal: "add",
        product: "add",
        category: "add",
        publisher: "add"
      },
      currentDeal: null,
      currentProduct: null,
      currentCategory: null,
      currentPublisher: null,
      currentDeletionItem: {},
      productFilter: "",
      dealFilter: ""
    };
  },
  components: {
    DealForm,
    ProductForm,
    CategoryForm,
    PublisherForm,
    DealTable,
    ProductTable
  },
  computed: {
    ...mapState({
      deals: state => state.deal.deals,
      products: state => state.product.products,
      categories: state => state.category.categories,
      publishers: state => state.publisher.publishers
    }),
    ...mapGetters({
      getPublisher: "publisher/getPublisher",
      getPublisherImage: "publisher/getImage",
      getCategoryName: "category/getName",
      getProduct: "product/getProduct",
      getProductImage: "product/getImage",
      getProductDealsCount: "deal/getProductDealsCount",
      getProductDealsPublisherImages: "deal/getProductDealsPublisherImages"
    }),
    orderedDeals() {
      let deals = filter(this.deals, deal => {
        if (this.dealFilter.length === 0) {
          return true;
        }

        let product = this.getProduct(deal.productId);
        let productFullName = `${product.brand} ${product.name} ${product.edition} ${product.colour}`;

        return (
          productFullName
            .toLowerCase()
            .indexOf(this.dealFilter.toLowerCase()) !== -1
        );
      });
      return orderBy(
        deals,
        [
          "updated_at",
          deal => {
            let product = this.getProduct(deal.productId);

            return product ? product.brand : null;
          },
          deal => {
            let product = this.getProduct(deal.productId);

            return product ? product.name : null;
          }
        ],
        ["desc", "asc", "asc"]
      );
    },
    orderedProducts() {
      let products = filter(this.products, product => {
        if (this.productFilter.length === 0) {
          return true;
        }

        let productFullName = `${product.brand} ${product.name} ${product.edition} ${product.colour}`;
        return (
          productFullName
            .toLowerCase()
            .indexOf(this.productFilter.toLowerCase()) !== -1
        );
      });
      return orderBy(products, ["brand", "name"], ["asc", "asc"]);
    }
  },
  methods: {
    ...mapActions({
      toggleProductLive: "product/toggleLive",
      toggleDealLive: "deal/toggleLive",
      deleteDeal: "deal/deleteDeal",
      deleteProduct: "product/deleteProduct"
    }),
    onChangeTab(index) {
      this.currentTab = index;
    },
    onSubmit(type) {
      setTimeout(() => {
        this.showModal[type] = false;
      }, 2000);
    },
    createDealFromProduct(id) {
      this.formMode.deal = "add";
      this.currentProduct = id;
      this.currentDeal = null;
      this.showModal.deal = true;
    },
    duplicateProduct(id) {
      this.formMode.product = "duplicate";
      this.currentProduct = id;
      this.showModal.product = true;
    },
    editDeal(id) {
      this.formMode.deal = "edit";
      this.currentDeal = id;
      this.showModal.deal = true;
    },
    peakDeal(url) {
      this.currentDeal = url;
      this.showModal.peakDeal = true;
    },
    editProduct(id) {
      this.formMode.product = "edit";
      this.currentProduct = id;
      this.showModal.product = true;
    },
    editCategory(id) {
      this.currentCategory = id;
      this.showModal.category = true;
    },
    editPublisher(id) {
      this.currentPublisher = id;
      this.showModal.publisher = true;
    },
    confirmDeleteProduct(id, name) {
      this.showModal.delete = true;
      this.currentDeletionItem = {
        type: "product",
        id,
        name
      };
    },
    confirmDeleteDeal(id, name) {
      this.showModal.delete = true;
      this.currentDeletionItem = {
        type: "deal",
        id,
        name
      };
    },
    deletePublisher() {},
    getProductName(productId) {
      let product = this.getProduct(productId);

      if (product) {
        return `${product.brand} ${product.name} ${product.edition || ""} ${
          product.colour
        }`;
      }
      return "Name not found";
    }
  },
  async mounted() {
    if (this.$route.hash) {
      this.currentTab = this.tabs
        .map(tab => tab.href)
        .indexOf(this.$route.hash);
    }

    try {
      const where = [["live", "==", false]];
      await this.$store.dispatch("product/openDBChannel", {
        clauses: {
          where
        }
      });
      await this.$store.dispatch("deal/openDBChannel", {
        clauses: {
          where
        }
      });
    } catch (e) {
      // Do nothing. Because the channel is already open.
      // console.log("TESTEST!!", e);
    }
  }
};
</script>

<style lang="scss" scoped>
.tab {
  background: $white;
  padding: $padding;
}

.results-info {
  padding: $padding-small 0;
  font-weight: 400;
}

table {
  width: 100%;

  tr:nth-of-type(2n) {
    background: $gray-lightest;
  }

  th,
  td {
    padding: 0.8rem;
    vertical-align: middle;
  }

  th {
    font-weight: 400;
  }
}
</style>
